import { API_URL } from '../config/app';

export interface WebsiteQuotePayload {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  projectType: 'vitrine' | 'ecommerce' | 'landing' | 'refonte' | 'autre';
  budget?: 'unknown' | 'under2k' | '2k5k' | '5k10k' | '10kplus';
  message: string;
  consent: boolean;
  /** Honeypot anti-bot : doit rester vide */
  website?: string;
}

export async function submitWebsiteQuoteRequest(
  payload: WebsiteQuotePayload
): Promise<void> {
  const res = await fetch(`${API_URL}/api/leads/website-quote`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  const data: { error?: string } = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new Error(
      typeof data.error === 'string' ? data.error : 'Envoi impossible'
    );
  }
}
